import { saveAs } from "file-saver";

export const makeTextFileForDownload = (data, fileName, extension) => {
  const type = `text/${extension.toLocaleLowerCase()};charset=utf-8`;
  const file = `${fileName}.${extension.toLocaleLowerCase()}`;
  const utf8BOM = [0xef, 0xbb, 0xbf];
  const array = new Uint8Array(utf8BOM);
  const blob = new Blob([array, "", data], {
    type,
  });

  return saveAs(blob, file, { autoBom: true });
};
